module.exports = __webpack_public_path__ + "static/media/logo-black.9eeb4fee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/img/logo-black.svg
// module id = 641
// module chunks = 8